import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconColumns3Wide: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconColumns3Wide"><Path d="M7.58984 20H4.75C3.23122 20 2 18.7688 2 17.25V6.75C2 5.23122 3.23122 4 4.75 4H7.58984V20Z" fill="currentColor"/><Path d="M14.9102 20H9.08984V4H14.9102V20Z" fill="currentColor"/><Path d="M19.25 4C20.7688 4 22 5.23122 22 6.75V17.25C22 18.7688 20.7688 20 19.25 20H16.4102V4H19.25Z" fill="currentColor"/></CentralIconBase>;
});

export default IconColumns3Wide;
